import http from '@/services/api';

const RESOURCE_NAME = 'api/agent';
let lastDirectCallState;

export default {
  register({ instanceId, terminal, useInternalPhone }) {
    return http.get(`${RESOURCE_NAME}/register`, { params: { instanceId, terminal, useInternalPhone } });
  },

  unRegister({ instanceId }) {
    return http.get(`${RESOURCE_NAME}/unregister`, { params: { instanceId } });
  },

  selectTerminal({ agentId, instanceId, terminal }) {
    return http.get(`${RESOURCE_NAME}/terminal/select`, { params: { instanceId, terminal } });
  },

  isAgentRegistered() {
    return http.get(`${RESOURCE_NAME}/registered`);
  },

  getAvailableBusinessProcesses(reqParams) {
    const params = reqParams ? { params: reqParams } : undefined;
    return http.get(`${RESOURCE_NAME}/current/businessProcess/all`, params);
  },

  getLoggedInAgentData({ orgName, orgId }) {
    return http.get(`${RESOURCE_NAME}/current`, { params: { orgName, orgId } });
  },

  getConversationHistory(interactionId) {
    return http.get(`${RESOURCE_NAME}/conversations/${interactionId}`);
  },

  postKeepAlive({ instanceId }) {
    return http.post(`${RESOURCE_NAME}/current/keepAlive`, { instanceId });
  },

  enableAutoOffHook() {
    return http.post(`${RESOURCE_NAME}/current/enableAutoOffHook`);
  },

  disableAutoOffHook() {
    return http.post(`${RESOURCE_NAME}/current/disableAutoOffHook`);
  },

  getLoggedInAgentState() {
    return http.get(`${RESOURCE_NAME}/current/state`);
  },

  updateLoggedInAgentState(stateId) {
    return http.put(`${RESOURCE_NAME}/current/state`, { stateId });
  },

  updateLoggedInAgentLoadAllowance(loadAllowanceId) {
    return http.put(`${RESOURCE_NAME}/current/loadAllowance`, { loadAllowanceId });
  },

  updateAgentCustomBreakState(customBreakId) {
    return http.put(`${RESOURCE_NAME}/current/breakState`, { customBreakId });
  },

  getAgentCallbacks() {
    return http.get(`${RESOURCE_NAME}/current/callbacks`);
  },

  getAgentById(agentId) {
    return http.get(`${RESOURCE_NAME}/${agentId}`);
  },

  getAgentsStats() {
    return http.get(`${RESOURCE_NAME}/all/stats`);
  },

  getCurrentAgentInteractions() {
    return http.get(`${RESOURCE_NAME}/current/interaction/all`);
  },

  getAvailableTerminals(agentId) {
    return http.get(`${RESOURCE_NAME}/${agentId}/terminals`);
  },

  getAgentsCurrentState() {
    return http.get(`${RESOURCE_NAME}/current/agentsCurrentState`);
  },

  markAsOnDirectCall(isOnDirectCall = false) {
    if (lastDirectCallState === isOnDirectCall) {
      return;
    }
    lastDirectCallState = isOnDirectCall;
    return http.post(`${RESOURCE_NAME}/current/markAsOnDirectCall`, { flag: isOnDirectCall });
  },

  closeAllInteractions(agentId) {
    return http.post(`${RESOURCE_NAME}/${agentId}/closeAllInteractions`, { params: { agentId } });
  },

  hangupInteraction({ agentId, interactionId }) {
    return http.post(`${RESOURCE_NAME}/${agentId}/interaction/${interactionId}/hangup`, {
      params: { agentId, interactionId }
    });
  }
};
